import { render } from "./SpaceFormPageOne.vue?vue&type=template&id=55449432"
import script from "./SpaceFormPageOne.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageOne.vue?vue&type=script&lang=js"
script.render = render

export default script